export const prospect = {
  profil : 'Prospect'
}
